import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const inputClass =
  'mt-2 bg-[#2A0A18] border-[#D4AF37]/30 text-[#F8F6F0] rounded-none focus:ring-1 focus:ring-[#D4AF37] focus-visible:ring-[#D4AF37] h-12 placeholder:text-[#B89A8B]';
const labelClass = 'text-[#E6CFC2] text-xs tracking-widest uppercase';

export const RegistrationForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ name: '', age: '', phone: '', batch: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await axios.post(`${API}/registrations`, {
        name: formData.name,
        age: parseInt(formData.age),
        phone: formData.phone,
        batch: formData.batch,
      });
      toast.success('Registration submitted successfully!');
      navigate('/success', { state: { ...formData } });
    } catch (error) {
      const errorMessage =
        error.response?.data?.detail || 'Failed to submit registration. Please try again.';
      toast.error(errorMessage);
      setIsSubmitting(false);
    }
  };

  return (
    <div className="bg-[#3A1226] border border-[#D4AF37]/25 p-8 md:p-10">
      <h3 className="font-heading text-2xl text-[#F8F6F0] mb-6">Complete Your Registration</h3>
      <form onSubmit={handleSubmit} className="space-y-6" data-testid="registration-form">
        <div>
          <Label htmlFor="name" className={labelClass}>Full Name *</Label>
          <Input
            id="name" name="name" value={formData.name} onChange={handleInputChange} required
            placeholder="Enter your full name" className={inputClass} data-testid="input-name"
          />
        </div>
        <div>
          <Label htmlFor="age" className={labelClass}>Age *</Label>
          <Input
            id="age" name="age" type="number" min="1" max="120" value={formData.age} onChange={handleInputChange} required
            placeholder="Enter your age" className={inputClass} data-testid="input-age"
          />
        </div>
        <div>
          <Label htmlFor="phone" className={labelClass}>Phone Number *</Label>
          <Input
            id="phone" name="phone" type="tel" value={formData.phone} onChange={handleInputChange} required
            placeholder="+91 XXXXX XXXXX" className={inputClass} data-testid="input-phone"
          />
        </div>
        <div>
          <Label htmlFor="batch" className={labelClass}>Preferred Batch *</Label>
          <select
            id="batch" name="batch" value={formData.batch} onChange={handleInputChange} required
            className="mt-2 w-full h-12 px-4 bg-[#2A0A18] border border-[#D4AF37]/30 text-[#F8F6F0] rounded-none focus:outline-none focus:ring-1 focus:ring-[#D4AF37]"
            data-testid="select-batch"
          >
            <option value="" className="bg-[#2A0A18]">Select a batch</option>
            <option value="morning" className="bg-[#2A0A18]">Morning Batch - 6:00 AM</option>
            <option value="day" className="bg-[#2A0A18]">Day Batch - 11:00 AM</option>
            <option value="evening" className="bg-[#2A0A18]">Evening Batch - 6:00 PM</option>
          </select>
        </div>
        <div className="border border-[#D4AF37]/15 bg-[#2A0A18] p-4">
          <p className="text-sm text-[#E6CFC2]">
            <span className="text-[#D4AF37]">Note:</span> Our team will contact you with the session details after you register.
          </p>
        </div>
        <Button
          type="submit"
          disabled={isSubmitting}
          className="w-full bg-gradient-to-r from-[#D4AF37] to-[#B5952F] text-[#2A0A18] font-semibold py-6 rounded-none uppercase tracking-widest text-sm hover:scale-[1.01] transition-transform disabled:opacity-70"
          data-testid="submit-registration-btn"
        >
          {isSubmitting ? 'Submitting...' : 'Complete Registration'}
        </Button>
      </form>
    </div>
  );
};
